module.exports = __webpack_public_path__ + "img/Lumina_island_treasure.56290cc5.png";